// import React from "react";
// import UpdateMeetingForm from "./UpdateMeetingForm";

// const UpdateMeetingDashboard = () => {
//   return (
//     <div className="admin-container">
//       <div className="max-w-xl w-full shadow-lg rounded-lg p-6 space-y-6">
//         <h2 className="text-3xl font-semibold text-gray-800 text-center">Update Session</h2>
//         <UpdateMeetingForm />
//       </div>
//     </div>
//   );
// };

// export default UpdateMeetingDashboard;


import React, { useEffect } from "react";
import Navbar from "../../components/Navbar";
import UpdateMeetingForm from "./UpdateMeetingForm";
import { useNavigate } from "react-router-dom";


const UpdateMeetingDashboard = ({
  setCurrentNickname,
  currentNickname,
  handleLogout,
  setFormType,
  PlutonicuserID,
  isAdmin
}) => {
    const navigate = useNavigate();
      useEffect(() => {
        if (!isAdmin) {
          navigate("/", { replace: true });
        }
      }, [isAdmin, navigate]);
  return (
    <div>
      <Navbar
        setCurrentNickname={(nickname) => {
          setCurrentNickname(nickname);
          localStorage.setItem("currentNickname", nickname);
        }}
        currentNickname={currentNickname}
        handleLogout={handleLogout}
        setFormType={setFormType}
        showButtons={true}
        PlutonicuserID={
          PlutonicuserID || localStorage.getItem("PlutonicuserID")
        }
      />
      <div className="mt-20 admin-container">
        <div className="max-w-xl w-full shadow-lg rounded-lg p-6 space-y-6">
          <h2 className="text-3xl font-semibold text-gray-800 text-center">Update Meeting</h2>
          <UpdateMeetingForm />
        </div>
      </div>
    </div>
  );
};

export default UpdateMeetingDashboard;
